import LinkWithLogin from './LinkWithLogin'

export default LinkWithLogin
